import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/products/:productId',
    name: 'productDetail',
    component: () => import('@/views/restricted/manufacturers/product/ProductDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_READ_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/products/create',
    name: 'productCreate',
    component: () => import('@/views/restricted/manufacturers/product/ProductCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/products/:productId/edit',
    name: 'productUpdate',
    component: () => import('@/views/restricted/manufacturers/product/ProductUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/products/:productId/breakdowns/create',
    name: 'productBreakdownCreate',
    component: () =>
      import('@/views/restricted/manufacturers/product/breakdown/ProductBreakdownCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/products/:productId/breakdowns/:productBreakdownId/edit',
    name: 'productBreakdownUpdate',
    component: () =>
      import('@/views/restricted/manufacturers/product/breakdown/ProductBreakdownUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  }
]
